module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125314.570b5a62.jpg";